import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: '',
  totalRegistros: 0
}

// getters
const getters = {
}

// actions
const actions = {
  async getGeneralTariff ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            conprod: data.conprod,
            producto: data.producto,
            subprodu: data.subproducto,
            vertiente: 'M'
          }
        }
      })

      const response = await HTTP.post(config.endpoints.tarifaGeneral, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async getCardsTariff ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            conprod: data.conprod,
            indtipt: 0,
            producto: data.producto,
            subprodu: data.subproducto,
            vertiente: 'M',
            codmar: 0
          }
        }
      })
      commit('TARIFF_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.tarifaTarjetas, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async getLoansTariff ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            conprod: data.conprod,
            producto: data.producto,
            subprodu: data.subproducto,
            vertiente: 'M',
            codtipc: ''
          }
        }
      })
      commit('TARIFF_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.tarifaPrestamos, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async getTramos ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            clamon_t: data.clamon_t,
            codconeco: data.codconeco,
            codmar: data.codmar,
            conprod: data.conprod,
            indtipt: data.indtipt,
            producto: data.producto,
            subprodu: data.subprodu,
            vertiente: 'M'
          }
        }
      })
      commit('TARIFF_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.tramos, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async getTramosPrestamos ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            clamonconc: data.clamon_t,
            codconeco: data.codconeco,
            codtipc: data.codtipc,
            conprod: data.conprod,
            producto: data.producto,
            subprodu: data.subprodu,
            tpacceconc: '',
            vertiente: 'M',
            trfincon: '0'
          }
        }
      })
      commit('TARIFF_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.tramosPrestamos, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async getTramosPrestamos2 ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            clamoncoef: 978,
            codconeco: data.codconeco.toString(),
            codtipc: data.codtipc,
            conprod: data.conprod.toString(),
            producto: data.producto,
            subprodu: data.subprodu,
            coecalimpf: data.portramoconc,
            vertiente: 'M'
          }
        }
      })
      commit('TARIFF_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.tramosPrestamos2, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'TARIFF_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'TARIFF_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'TARIFF_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.totalRegistros = datos.totalRegistros
    state.code = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'TARIFF_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesión expirada'
    } else if (payload.retorno === 210) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.code = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
